import { forwardRef } from 'react'
import { Box, BoxProps } from '@mui/material'
import { motion } from 'framer-motion'

const BoxComponent = forwardRef((props: BoxProps, ref) => (
  <Box {...props} ref={ref}/>
))

export default motion(BoxComponent, { forwardMotionProps: true })
